/**
 * Service rate basis catalogue. Used in CreateListing, ListingCard, and
 * ListingDetail to keep labels consistent.
 */
export const RATE_BASIS_OPTIONS = [
  { value: "hour",    label: "per hour",    short: "/ hr",      long: "/ hour"   },
  { value: "session", label: "per session", short: "/ session", long: "/ session"},
  { value: "day",     label: "per day",     short: "/ day",     long: "/ day"    },
  { value: "project", label: "per project", short: "/ project", long: "/ project"},
  { value: "fixed",   label: "fixed price", short: "",          long: ""         },
];

export const rateBasisSuffix = (basis, variant = "short") => {
  const entry = RATE_BASIS_OPTIONS.find((o) => o.value === (basis || "hour"));
  return entry?.[variant] ?? "";
};
